import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'powerpayCurrency',
})
export class PowerpayCurrencyPipe implements PipeTransform {
  transform(value: string, hideSymbol?: boolean): string {
    value = value ?? '0';
    const numberWithFormat = Number(value).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    const symbol = 'S/';
    return hideSymbol ? numberWithFormat : `${symbol} ${numberWithFormat}`;
  }
}
